import axios from "axios";
import config from "../config/config";

const API_URL = config.API_URL;

const getHeaders = () => {
    const token = localStorage.getItem('authToken') || localStorage.getItem('token');
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json"
        }
    };
};

const buildPaymentFormData = (data, isUpdate = false) => {
    if (typeof FormData !== "undefined" && data instanceof FormData) {
        if (isUpdate && !data.has("_method")) {
            data.append("_method", "PUT");
        }
        return data;
    }
    const formData = new FormData();
    const fields = {
        name: data?.name ?? data?.paymentName,
        paymentName: data?.paymentName ?? data?.name,
        code: data?.code,
        type: data?.type,
        price: data?.price,
        account_number: data?.account_number ?? data?.accountNumber,
        account_name: data?.account_name ?? data?.accountName,
        description: data?.description ?? data?.instructions,
        instructions: data?.instructions ?? data?.description,
        status: data?.status,
    };
    Object.keys(fields).forEach((key) => {
        if (fields[key] !== undefined && fields[key] !== null && fields[key] !== "") {
            formData.append(key, fields[key]);
        }
    });
    if (data?.logo) {
        formData.append("logo", data.logo);
    }
    if (isUpdate) {
        formData.append("_method", "PUT");
    }
    return formData;
};

export const storePayment = async (data) => {
    const payload = buildPaymentFormData(data, false);
    const response = await axios.post(`${API_URL}payment`, payload, getHeaders());
    return response.data;
};

export const getPayment = async () => {
    const response = await axios.get(`${API_URL}payment`, getHeaders());
    return response.data;
};

export const getDetailPayment = async (id) => {
    const response = await axios.get(`${API_URL}payment/${id}`, getHeaders());
    return response.data;
};

export const deletePayment = async (id) => {
    const response = await axios.delete(`${API_URL}payment/${id}`, getHeaders());
    return response.data;
};

export const updatePayment = async (id, data) => {
    const payload = buildPaymentFormData(data, true);
    const response = await axios.post(`${API_URL}payment/${id}`, payload, getHeaders());
    return response.data;
};
